import { JWT_TOKEN } from "../../global/constants";
import { LOGIN_REQUEST, LOGIN_SUCCESS, LOGIN_ERROR, LOGOUT, MFA_REQUIRED } from "../types";

const initialState = {
  isFetching: false,
  isAuth: false,
  user: {},
  error: "",
  ssoUrl: null,
  mfaRequired: false,
  tempToken: null,
};
// eslint-disable-next-line
export default function (state = initialState, action) {
  switch (action.type) {
    case LOGIN_REQUEST:
      return {
        ...state,
        isFetching: true,
      };
    case LOGIN_SUCCESS:
      return {
        ...state,
        isFetching: false,
        isAuth: true,
        tempToken: null,
        mfaRequired: false,
        error: "",
        user: action.payload,
      };
    case MFA_REQUIRED:
      return { ...state, isFetching: false, mfaRequired: true, tempToken: action.payload };
    case LOGIN_ERROR:
      localStorage.removeItem(JWT_TOKEN);
      return {
        ...state,
        isFetching: false,
        isAuth: false,
        error: action.payload,
        ssoUrl: action.ssoUrl || null,
      };
    case LOGOUT:
      localStorage.removeItem(JWT_TOKEN);
      return {
        ...state,
        isFetching: false,
        isAuth: false,
        user: {},
      };
    default:
      return state;
  }
}
